import React, { useEffect } from 'react';
import Layout from '@/common/Layout';
import TermsConditions from './components/Terms.js';

const index = () => {
  useEffect(() => {
    document.title = 'Cancellation & Refund Policy - Membership Terms';
  }, []);

  return (
    <>
      <Layout
        // sider={true}
        hideHeader={true}
      >
        <TermsConditions />
      </Layout>
    </>
  );
};

export default index;
